import { getApp, getApps, initializeApp } from "firebase/app";
import {
  initializeAppCheck,
  ReCaptchaV3Provider,
} from "firebase/app-check";
import { getAuth, signInAnonymously } from "firebase/auth";
import { getDatabase } from "firebase/database";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

const appCheckSiteKey = process.env.REACT_APP_FIREBASE_APP_CHECK_SITE_KEY;
const appCheckDebugToken = process.env.REACT_APP_FIREBASE_APP_CHECK_DEBUG_TOKEN;

export const isFirebaseSecurityConfigured = Boolean(
  firebaseConfig.apiKey &&
    firebaseConfig.authDomain &&
    firebaseConfig.databaseURL &&
    firebaseConfig.projectId &&
    firebaseConfig.appId &&
    appCheckSiteKey,
);

const firebaseApp = isFirebaseSecurityConfigured
  ? getApps().length
    ? getApp()
    : initializeApp(firebaseConfig)
  : null;

if (firebaseApp && typeof window !== "undefined") {
  if (appCheckDebugToken) {
    Object.assign(window, {
      FIREBASE_APPCHECK_DEBUG_TOKEN:
        appCheckDebugToken === "true" ? true : appCheckDebugToken,
    });
  }

  initializeAppCheck(firebaseApp, {
    provider: new ReCaptchaV3Provider(appCheckSiteKey as string),
    isTokenAutoRefreshEnabled: true,
  });
}

export const firebaseAuth = firebaseApp ? getAuth(firebaseApp) : null;
export const firebaseDatabase = firebaseApp ? getDatabase(firebaseApp) : null;

export const ensureAnonymousUser = async () => {
  if (!firebaseAuth) {
    throw new Error("Firebase security is not configured.");
  }

  if (firebaseAuth.currentUser) {
    return firebaseAuth.currentUser;
  }

  const credential = await signInAnonymously(firebaseAuth);
  return credential.user;
};
